<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">设备类型<span>*</span></p>
          <div class="write-text">
            <el-radio-group v-model="addObj.type">
              <el-radio label="1">苹果</el-radio>
              <el-radio label="2">安卓</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">档位名称<span>*</span></p>
          <div class="write-text">
            <input type="text" placeholder="请输入包名称"  v-model="addObj.title">
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">价格<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入价格"  v-model="addObj.price">
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">到账积分<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入到账积分"  v-model="addObj.credits">
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">积分有效期<span>*</span></p>
          <div class="write-text">
            <input type="number" class="num" v-model="addObj.credits_time" @change="$forceUpdate()">
            <el-radio-group v-model="vip_date" style="display: inline-block;vertical-align: middle;">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">排序<span>*</span></p>
          <el-select v-model="addObj.sort" placeholder="请选择">
            <el-option
              v-for="item in 10"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="write-txt">
          <p class="write-title">是否默认选中<span>*</span></p>
            <el-radio-group v-model="addObj.is_selected">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="ModelHide">取消</button>
        </div>
      </div>
      <div class="MobelBox" v-else-if="CreditsType">
        <div class="write-txt">
          <p class="write-title">赠送额度<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入价格"  v-model="CreditsObj.credits">
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">积分有效期<span>*</span></p>
          <div class="write-text">
            <input type="number" class="num" v-model="CreditsObj.credits_time" @change="$forceUpdate()">
            <el-radio-group v-model="vip_date" style="display: inline-block;vertical-align: middle;">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="CreditSub">保存</button>
          <button class="btn btn-close" @click="CreditHide">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加充值档位</p>
          </div>
          <div class="organiza-left" @click="CreditShow">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>新用户赠送积分设置</p>
          </div>
          <div class="searchBox clear hide">
            <div class="search-item">
              <p>包名称：</p>
              <input type="text" placeholder="请输入要搜索的包名称" v-model="obj.uid">
            </div>
            <div class="search-item">
              <p>排序：</p>
              <el-select v-model="obj.sort" placeholder="请选择">
                <el-option label="升序" value="asc"></el-option>
                <el-option label="降序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>状态：</p>
              <el-select v-model="obj.publish_status" placeholder="请选择">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>创建时间：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option label="升序" value="asc"></el-option>
                <el-option label="降序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.credits">{{item.credits}}</p>
              <p :title="item.price">{{item.price}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCreditsList ,saveCredits ,getCreditsDetail ,delCredits ,updateCreditsStatus,saveSystemSet,getSystemSet} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "pkgList",
  data() {
    return {
      navId:'19',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'名称'},
        {id:3,title:'积分数量'},
        {id:4,title:'价格'},
        {id:5,title:'添加时间'},
        {id:6,title:'是否发布'},
        {id:7,title:'操作'},
      ],
      dataList:[],
      token:'',
      obj:{
        page:1,
        rows:10,
      },
      totalPage:0,
      addType:'',
      addObj:{
        type:'2',
        title:'',
        price:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:'',
        practice_time:''
      },
      vip_date:'d',
      removeType:false,
      removeID:'',
      CreditsType:false,
      CreditsObj:{
        credits:'',
        credits_time:''
      }
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
  },
  methods: {

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getCreditsList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10
      };
      this.dataList = [];
      this.getList();
    },

    addSub(){
      this.addType = 'add';
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updateCreditsStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getCreditsDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = {
            type: JSON.stringify(response.data.type),
            title: response.data.title,
            price: response.data.price,
            sort: response.data.sort,
            is_selected: JSON.stringify(response.data.is_selected),
            credits: response.data.credits,
            credits_time: '',
            id:response.data.id
          };
          var time = '';
          response.data.credits_time.split('').forEach(function(item,index){
            if(index == (response.data.credits_time.split('').length-1)){

            } else {
              time = time + item
            }
          });
          that.addObj.credits_time = time;
          
          that.vip_date = JSON.parse(JSON.stringify(response.data.credits_time.split('')[response.data.credits_time.split('').length-1]));
          console.log(that.vip_date)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async saveSub(){
      var that = this;
      console.log(this.addObj,'==addObj==');
      if(this.addObj.title == ''){
        that.$message('请输入档位名称');
        return false;
      }
      if(this.addObj.credits_time == ''){
        that.$message('请输入有效期');
        return false;
      }
      if(this.addObj.price == ''){
        that.$message('请输入价格');
        return false;
      }
      if(this.addObj.sort == ''){
        that.$message('请选择排序');
        return false;
      }
      this.addObj.credits_time = this.addObj.credits_time + this.vip_date;
      try {
        const response = await saveCredits(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.resetSub();
          that.addType = '';
          that.addObj = {
            type:'2',
            title:'',
            price:'',
            vip_time:'',
            sort:'',
            is_selected:'1',
            act_str:'',
            practice_time:''
          };
          that.vip_date = 'd';
          that.getList(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delCredits({id:that.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.resetSub();
          that.getList(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(){
      var that = this;
      that.addType = '';
      this.removeType = false;
      this.removeID = '';
      that.addObj = {
        type:'2',
        title:'',
        price:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:'',
        practice_time:''
      };
      that.vip_date = 'd';
    },

    async CreditShow(){
      var that = this;
      try {
        const response = await getSystemSet(this.token);
        if(response.code == 200){
          that.CreditsObj = response.data;
          if(response.data.credits_time == ''){
            that.vip_date = 'd';
          } else {
            that.vip_date = JSON.parse(JSON.stringify(response.data.credits_time.split('')[response.data.credits_time.split('').length-1]));
          }
          var time = '';
          response.data.credits_time.split('').forEach(function(item,index){
            if(index == (response.data.credits_time.split('').length-1)){

            } else {
              time = time + item
            }
          });
          that.CreditsObj.credits_time = time;
          that.CreditsType = true;
          console.log(response.data.credits_time)
          console.log(JSON.stringify(response.data.credits_time.split('')[response.data.credits_time.split('').length-1]))
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    CreditHide(){
      this.CreditsObj = {
        credits:'',
        credits_time:''
      };
      this.CreditsType = false;
      this.vip_date = 'd';
    },

    async CreditSub(){
      var that = this;
      if(this.CreditsObj.credits == ''){
        that.$message('请填写赠送额度');
        return false;
      }
      if(this.CreditsObj.credits_time == ''){
        that.$message('请填写有效期');
        return false;
      }
      this.CreditsObj.credits_time = this.CreditsObj.credits_time + this.vip_date;
      console.log(this.CreditsObj);
      try {
        const response = await saveSystemSet(this.CreditsObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.CreditHide();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 7 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .organiza-left{
    float: left;
    display: block;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .searchBox{
    margin-top: 0;
  }

  .search-item>>> input,
  .search-item>>> .el-select,
  .search-item input{
    width: 200px;
  }


  
.MobelBox {
  padding: 40px;
  box-sizing: border-box;
  width: 100%;
  height: calc( 100% - 100px );
  overflow-y: auto;
  overflow-x: hidden;
}

.MobelBox .write-txt {
  display: block;
  width: 100%;
  margin-bottom: 40px;
}

.MobelBox .write-title {
  font-size: 18px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  width: 160px;
}

.MobelBox .write-title span {
  color: #e2231a;
}

.MobelBox .write-text {
  display: inline-block;
  vertical-align: top;
  width: 80%;
  margin-left: 20px;
}

.MobelBox .write-text span {
  font-size: 14px;
  color: #e2231a;
  margin-top: 10px;
  display: block;
}

.MobelBox input,
.MobelBox textarea {
  width: 80%;
  height: 65px;
  background-color: #f5f5f5;
  border-radius: 16px;
  display: block;
  padding: 10px;
  box-sizing: border-box;
}

.MobelBox input{
  width: 400px;
}

.MobelBox input.num{
  width: 100px;
  padding: 0 10px;
  margin-right: 20px;
  background-color: #f5f5f5;
  height: 50px;
  line-height: 50px;
  border-radius: 16px;
  display: inline-block;
  vertical-align: middle;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/points/index.vue